<template>
  <div id="tdtMap"></div>
</template>

<script>
import Axios from "@/utils/Axios";
import Bus from "@/utils/bus.js";
import lev1 from '../../../../../assets/home/lev1.png';
import lev2 from '../../../../../assets/home/lev2.png';
import lev3 from '../../../../../assets/home/lev3.png';
import lev4 from '../../../../../assets/home/lev4.png';
import lev5 from '../../../../../assets/home/lev5.png';
import lev6 from '../../../../../assets/home/lev6.png';
export default {
  data() {
    return {
      T: null,
      map: null,
    }
  },
  components: {
  },
  created() {
  },
  mounted() {
    let that=this
    //this.BMapGL = window.BMapGL;
    this.T = window.T;

    this.getmapfircenter()

    Bus.$on("changeid", (val) => {


      that.getmapcenter(val.deptId)

    });
  },
  methods: {
    getmapcenter(id){
      let that=this
      const param = {
        url: "/dept/center",
        method: "post",
        data: {
          deptId: id,
        },
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {


          //var point = new BMapGL.Point(res.data.lng, res.data.lat);

          var point = new T.LngLat(res.data.lng, res.data.lat);

          let zoom=null
          if(res.data.districtLevel=='country'){
            zoom=8
          }else if(res.data.districtLevel=='province'){
            zoom=10
          }else if(res.data.districtLevel=='city'){
            zoom=11
          }else if(res.data.districtLevel=='district'){
            zoom=15
          }else if(res.data.districtLevel=='street'){
            zoom=19
          }

          that.map.panTo(point); // 设置地图中心点

          that.map.setZoom(zoom); // 设置地图层级
        }

      });
    },

    getmapfircenter(){
      let that=this
      const param = {
        url: "/dept/userCenter",
        method: "post",
        data: {

        },
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {

          this.initMap(res.data);

        }

      });
    },
    initMap (alldata) {
      let that=this
      //this.map = new this.BMapGL.Map('bdMap11');    // 创建Map实例

      // 初始化天地图
      this.map = new T.Map('tdtMap', {
        projection: "EPSG:4326",
        minZoom: 3,  // 设置最小缩放级别
        maxZoom: 19  // 设置最大缩放级别
      });

      var globalBounds = new T.LngLatBounds(
        new T.LngLat(-180, -90),  // 西南角（最小经纬度）
        new T.LngLat(180, 90)     // 东北角（最大经纬度）
      );

      //设置拖拽范围
      this.map.setMaxBounds(globalBounds);

      let zoom=6

      //this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
      //this.map.setHeading(64.5);
      //this.map.setTilt(73);
      //this.map.setMapStyleV2({styleJson: this.styleJson1});
      //this.map.centerAndZoom(new this.BMapGL.Point(alldata.lng,alldata.lat), zoom);  // 初始化地图,设置中心点坐标和地图级别

      // 添加地图控件
      this.map.addControl(new T.Control.Zoom());
      this.map.addControl(new T.Control.Scale());
      
      // 设置地图中心点和缩放级别
      this.map.centerAndZoom(new T.LngLat(alldata.lng, alldata.lat), zoom);

      this.map.setStyle("indigo");

      this.getpointList()
      // 监听地图层级
      this.map.addEventListener("zoomend", function(e) {
        var ZoomNum = that.map.getZoom();
        setTimeout(function(){

          that.clearAllOverlays();

          if(ZoomNum<13){
            for(let i=0;i<that.staarr.length;i++){
              that.setposition2(that.staarr[i])
            }
          }else{
            for(let i=0;i<that.staarr.length;i++){
              that.setposition(that.staarr[i])

            }
          }
        },500)

      })

    },

    // 清除所有覆盖物
    clearAllOverlays() {
      if (this.map) {
        this.map.clearOverLays();
      }
    },


    // 创建图标
    createIcon(riskLevel) {
      let iconUrl = '';
      switch (riskLevel) {
        case 1:
          iconUrl = lev1;
          break;
        case 2:
          iconUrl = lev2;
          break;
        case 3:
          iconUrl = lev3;
          break;
        case 4:
          iconUrl = lev4;
          break;
        case 5:
          iconUrl = lev5;
          break;
        case 6:
          iconUrl = lev6;
          break;
        default:
          iconUrl = lev6;
      }
      
      // 天地图创建图标
      return new T.Icon({
        iconUrl: iconUrl,
        iconSize: new T.Point(33, 40),
        iconAnchor: new T.Point(16, 40)
      });
    },
    
    
    setposition(sta) {
      let that = this;
      
      if (sta.lat && sta.lng) {
        var point = new T.LngLat(sta.lng, sta.lat);
        
        // 创建标记
        var marker = new T.Marker(point, {
          icon: this.createIcon(sta.mostSeriousRiskLevel)
        });
        
        // 添加标记到地图
        this.map.addOverLay(marker);
        
        // 创建文本标注
        var labelOptions = {
          position: point,
          offset: new T.Point(10, -40)
        };
        
        var label = new T.Label(sta.deptName, labelOptions);
        
        // 设置文本标注样式
        label.setStyle({
          color: 'rgb(250,220,20)',
          backgroundColor: "transparent",
          fontSize: "12px",
          fontFamily: "微软雅黑",
          padding: "5px",
          border: "none",
          whiteSpace: "nowrap"
        });
        
        this.map.addOverLay(label);
        
        // 添加点击事件
        marker.addEventListener("click", function (e) {
          // that.getstaList(sta.deptId)
          // that.deptName = sta.deptName
          // that.showtc = true
          console.log('标记点点击:', sta.deptName);
        });
      }
    },

    setposition2(sta) {
      let that = this;
      
      if (sta.lat && sta.lng) {
        var point = new T.LngLat(sta.lng, sta.lat);
        
        var marker = new T.Marker(point, {
          icon: this.createIcon(sta.mostSeriousRiskLevel)
        });
        
        this.map.addOverLay(marker);
        
        marker.addEventListener("click", function (e) {
          // that.getstaList(sta.deptId)
          // that.deptName = sta.deptName
          // that.showtc = true
          console.log('标记点点击:', sta.deptName);
        });
      }
    },

    getpointList(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/bigScreen/regionalPosition";
      param.data={

      }
      Axios.ajax(param).then((res)=>{
        if(res.data){
          this.staarr=res.data

          for(let i=0;i<res.data.length;i++){
            if(res.data[i].lat && res.data[i].lng) {

              if(i==0){

              }
              that.setposition2(res.data[i])
            }

          }
        }

      })
    },
  },
}
</script>

<style lang="scss" scoped>
.bm-view {
  width: 100%;
  height: 100%;
  position: relative;
}

#tdtMap {
  width: 100%;
  height: calc(100% - 87px);
  top: 87px;
  position: fixed !important;
  z-index: 0;
  background-color: #041c75ff;
}

</style>
